import { CSSProperties } from 'fela';
import { FelaCSS, alpha, colors } from '@bridebook/ui';
import { ISharedProps as IStyleProps } from './index';

interface IStyles {
  wrapper: FelaCSS;
  additionalWrapper: CSSProperties;
}

const styles = ({ featured, isMobile, fullBleed }: IStyleProps): IStyles => ({
  wrapper: {
    position: 'relative',
    marginTop: featured && isMobile ? 4 : '0',
    overflow: 'hidden',
    borderRadius: '16px',
    ...(!fullBleed && { boxShadow: `0px 0px 6px 0px ${alpha(colors.black, 15)}` }),

    desktopDesign: {
      backgroundColor: colors.white,
    },
  },
  additionalWrapper: { position: 'relative' },
});

export default styles;
